<template>
    <div class="c-widget">
        <div class="c-widget__header">
            <span class="handle mr-4">::</span>{{ label }}
            <div class="c-widget__header-controls">
                <slot name="pin" class="float-right"></slot>
                <slot name="remove" class="float-right"></slot>
            </div>
        </div>
        <div class="c-widget__content">
            LIST
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            label: String,
            definition: Object
        },
        components: {}
    };
</script>
